// extracted by mini-css-extract-plugin
export default {"main":"DeleteNote_main__PVqzb","question":"DeleteNote_question__u1ySt","nota":"DeleteNote_nota__r-d0b"};